export enum UpdateFamilyIncomeConst {
  UPDATE_FAMILY_INCOME = 'UPDATE:FAMILY_INCOME',
  UPDATE_FAMILY_INCOME_OK = 'UPDATE:FAMILY_INCOME:OK',
  UPDATE_FAMILY_INCOME_KO = 'UPDATE:FAMILY_INCOME:KO',
}
